import { change } from 'redux-form';
import _ from 'lodash';

import * as types from './types';
import { loading, success, error } from 'State/actions';
import { ReportGeneration } from 'Common/ObjectHelper';
import { WarehouseReportEnum } from 'Common/FieldEnum';
import { WAREHOUSE_KITCHEN_LOAD_FORM_NAME } from 'Common/FormEnum';

export const getWarehouseKitchenList = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.FETCH_WAREHOUSE_KITCHEN_LIST_LOADING, true));
    try {
      const response = await MPWWebApi.getGeneric('sitemaster');
      dispatch(
        success(types.WAREHOUSE_KITCHEN_LIST_DATA, response.data.Data)
      );
    } catch (ex) {
      dispatch(error(types.FETCH_WAREHOUSE_KITCHEN_LIST_LOADING_ERROR, ex));
    } finally {
      dispatch(loading(types.FETCH_WAREHOUSE_KITCHEN_LIST_LOADING, false));
    }
  };
};

export const getPrintLoad = printRequestData => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.PRINT_WAREHOUSE_KITCHEN_LOAD_REPORTS_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'WarehouseReports/GetPrintLoad',
        printRequestData
      );
      if (_.has(response, 'data.Data.Data')) {
        ReportGeneration(
          response.data.Data.Data,
          "Warehouse/Kitchen Availability Report's"
        );
      }
    } catch (err) {
      dispatch(error(types.PRINT_LOADING_ERROR, err));
    } finally {
      dispatch(
        loading(types.PRINT_WAREHOUSE_KITCHEN_LOAD_REPORTS_LOADING, false)
      );
    }
  };
};

export const getTruckRouteList = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.FETCH_TRUCK_ROUTE_LIST_LOADING, true));
    try {
      const response = await MPWWebApi.getGeneric(
        'WarehouseReports/GetTruckRoute'
      );
      dispatch(success(types.TRUCK_ROUTE_LIST_DATA, response.data.Data));
    } catch (ex) {
      dispatch(error(types.FETCH_TRUCK_ROUTE_LIST_LOADING_ERROR, ex));
    } finally {
      dispatch(loading(types.FETCH_TRUCK_ROUTE_LIST_LOADING, false));
    }
  };
};

export const setWarehouseKitchenValue = (warehouseValue, fromName) => {
  return (dispatch, getState, MPWWebApi) => {
    dispatch(
      change(fromName, WarehouseReportEnum.WarehouseKitchen, warehouseValue)
    );
  };
};
export const clearPrintLoadingError = () => {
  return {
    type: types.CLEAR_PRINT_LOADING_ERROR,
  };
};
export const changeDropDownData = (dropDownName, data) => {
  return change(WAREHOUSE_KITCHEN_LOAD_FORM_NAME, dropDownName, data);
};



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/warehousepicklist/state/actions.js